/**
 * Set webpack public path for Electron file:// protocol
 * This MUST be imported first in index.tsx before any other imports
 */

declare let __webpack_public_path__: string;

// In Electron (file:// protocol), webpack needs to know where to load chunks from
if (window.location.protocol === 'file:') {
  // Compute the folder that index.html is in and use that as the base
  // new URL('./', ...) gives us the directory with trailing slash
  __webpack_public_path__ = new URL('./', window.location.href).toString();
  console.log('🔧 [ELECTRON] Set webpack public path to:', __webpack_public_path__);
} else {
  // For web (http://), use root path
  __webpack_public_path__ = '/';
  console.log('🌐 [WEB] Using root public path');
}

